// fontselect
import './fontselect/jquery.fontselect.min.css';
import './fontselect/jquery.fontselect.min.js';

import './style.scss';

// Custom JSON to download
import './_partialsJS/customStyleJSON.js';
import './_partialsJS/customJSON.js';

// Window Components
import './_partialsJS/elements/background.js';
import './_partialsJS/elements/header.js';
import './_partialsJS/elements/avatar.js';
import './_partialsJS/elements/menu.js';
import './_partialsJS/elements/webchat-input.js';

// Chat Components
import './_partialsJS/elements/bot-bubble.js';
import './_partialsJS/elements/user-bubble.js';
import './_partialsJS/elements/quick-reply.js';
import './_partialsJS/elements/link-button.js';
import './_partialsJS/elements/image-video.js';
import './_partialsJS/elements/gallery.js';

// Global Settings
import './_partialsJS/elements/fonts.js';
import './_partialsJS/elements/colors.js';
import './_partialsJS/elements/cognigyEndpoint.js';


import './_partialsJS/files.js';

import '@fortawesome/fontawesome-free/js/all.js';
import './cognigy/webchat.js';
import './cognigy/webchat.legacy.js';

window.loadWebsite = function() {
    document.body.style.opacity = 1;

    var endpoint = 'https://endpoint-trial.cognigy.ai/0a526b01f6e73a2d5abe68bd6b2bf4cbf626468d5919c83b9272dbf213c6ecec';
    var settings = document.getElementsByClassName("settings-container")[0];

    var settingsClose = document.getElementsByClassName("settings")[0];
    settingsClose.addEventListener("click", function(event){
        if (settingsClose.classList.contains("settings-close")) {
            window.toggleSettings("config");
        }
    })

    // OPEN/CLOSE SETTINGS
    window.toggleSettings = function(_element) {
        var container = document.getElementsByClassName("container")[0];
        container.classList.toggle("show-settings");
        settingsClose.classList.remove("settings-close");
    }

    var crossSettings = document.getElementById("settings-close");
    crossSettings.addEventListener("click", function(event) {
        event.stopPropagation();
        var container = document.getElementsByClassName("container")[0];
        settingsClose.classList.add("settings-close");
        container.classList.toggle("show-settings");
    })

    // OPEN/CLOSE PAYLOADS
    window.togglePayloads = function(_element) {
        var container = document.getElementsByClassName("container")[0];
        var icons = document.getElementsByClassName("togglePayloads")[0];
        if (!container.classList.contains('show-payloads')) {
        }

        container.classList.toggle("show-payloads");
        icons.classList.toggle("show-payloads");
    }

    // OPEN SETTINGS ELEMENT CONTENT
    const settingsHeaderElements = document.querySelectorAll('.settings-block-header');
    settingsHeaderElements.forEach(el => el.addEventListener('click', event => {
    event.currentTarget.classList.toggle("show");
    event.currentTarget.nextSibling.classList.toggle("show");
    }));

    const settingsSubHeaderElements = document.querySelectorAll('.settings-sub-block-header');
    settingsSubHeaderElements.forEach(el => el.addEventListener('click', event => {
    event.currentTarget.classList.toggle("show");
    event.currentTarget.nextSibling.classList.toggle("show");
    }));

    const settingsSubSubHeaderElements = document.querySelectorAll('.settings-sub-sub-block-header');
    settingsSubSubHeaderElements.forEach(el => el.addEventListener('click', event => {
        event.currentTarget.classList.toggle("show");
        event.currentTarget.nextSibling.classList.toggle("show");
    }));

    // INIT TEMPLATE CHATBOT
    function cloneWebchat() {
        var r = document.getElementsByClassName("webchat-root")[0];
        document.getElementsByClassName('conversation')[0].appendChild(r);
    }

    var checkWebchat = setInterval(function(){
        if (document.getElementsByClassName('webchat-root')[0]) {
            if ( document.getElementsByClassName('webchat-root')[0].length != 0 ) {
                cloneWebchat();
                document.getElementsByClassName('webchat-root')[0].style.opacity = 1;        
                clearInterval(checkWebchat);
            }
        }
    })

    initWebchat(endpoint, {
        settings: {
            colorScheme: '#FFF',
            getStartedText: "",
            startBehavior: 'injection',
            inputPlaceholder: 'Deine Nachricht an mich'
        },
        forceWebsockets: true
    }). then(function(webchat) {
        window.cognigyWebchat = webchat;        
        webchat.open();
    });
}